// extracted by mini-css-extract-plugin
export default {"container":"vyjw2_lkbqOaiFnKsrTB","headerContainer":"BRgO7rKhdjY4vFSihvLw","title":"DJEIo9KM1OMKNjg1mIg2","subtitle":"b5ENjZLhxQsWWE8knQCa","visibleOverflow":"MWiflGJ11ewXTz2yXoNZ"};